import React, { Component } from 'react'
import gql from 'graphql-tag'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import FormGroup from '@material-ui/core/FormGroup'
import TextField from '@material-ui/core/TextField'
import FormControl from '@material-ui/core/FormControl'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import RadioGroup from '@material-ui/core/RadioGroup'
import Radio from '@material-ui/core/Radio'
import CustomTabs from '../../Modules/CustomTabs'
import { Query, withApollo } from 'react-apollo'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Select from 'react-select'
import getLoginId from '../../../utils/getLoginId'
import withSharedSnackbar from '../../HOCs/withSharedSnackbar'
import FormHelperText from '@material-ui/core/FormHelperText'
import moment from 'moment'
import { DateTimePicker } from 'material-ui-pickers'
import { Checkbox } from '@material-ui/core'
import Loader from '../../../components/common/Loader'
import ConfirmationalDialog from '../../common/ConfirmationDialog'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import CardContent from '@material-ui/core/CardContent'
import CardActions from '@material-ui/core/CardActions'
import Countries from '../../Modules/Countries'
const styles = theme => ({
  root: {
    padding: theme.spacing.unit * 4,
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing.unit * 2
    },
    flexGrow: 1
  },
  italicizedText: {
    fontStyle: 'italic'
  }
})

const GET_CLIENT = gql`
  query clientDetail($loginId: Int) {
    clientDetail(loginId: $loginId) {
      id
      loginId
      clientName
      prorata
      contactPerson
      secondaryContactName
      secondaryEmail
      secondaryContactNumber
      address
      clientType
      registrationType
      shippingAddress
      shippingCity
      shippingPincode
      city
      timezone
      minimumTrackedDays
      packetThreshold
      gst
      state {
        zone_id
      }
      country {
        country_id
      }
      shippingState {
        zone_id
      }
      shippingCountry {
        country_id
      }
      email
      contactNumber
      login {
        username
      }
      plan {
        id
        planName
      }
      pincode
      panNumber
      type
      expiryDate
      solution

      billingMode {
        id
        billingMode
      }
      salesPerson {
        id
        name
      }
    }
  }
`

const UPDATE_CLIENT = gql`
  mutation(
    $id: Int!
    $clientName: String!
    $login_id: Int!
    $email: String!
    $contactPerson: String!
    $contactNumber: String!
    $secondaryContactName: String
    $secondaryContactNumber: String
    $secondaryEmail: String
    $address: String!
    $city: String!
    $state_id: Int!
    $country_id: Int!
    $pincode: Int
    $panNumber: String
    $clientType: String!
    $status: Int!
    $partnerLoginId: Int
    $registrationType: String
    $timezone: String!
    $gst: String
    $plan: Int
    $username: String!
    $typeOfClient: ClientPartnerType!
    $shippingAddress: String
    $shippingCountry: Int
    $shippingState: Int
    $shippingCity: String
    $shippingPincode: Int
    $expiryDate: String
    $solution: String!
    $billingMode: Int!
    $salesPersonId: Int
    $prorata: Int!
    $minimumTrackedDays: Int!
    $packetThreshold: Int
  ) {
    updateClientDetail(
      id: $id
      clientName: $clientName
      login_id: $login_id
      email: $email
      contactPerson: $contactPerson
      contactNumber: $contactNumber
      secondaryContactName: $secondaryContactName
      secondaryContactNumber: $secondaryContactNumber
      secondaryEmail: $secondaryEmail
      address: $address
      city: $city
      state_id: $state_id
      country_id: $country_id
      pincode: $pincode
      panNumber: $panNumber
      clientType: $clientType
      status: $status
      partnerLoginId: $partnerLoginId
      timezone: $timezone
      gst: $gst
      plan_id: $plan
      loginUsername: $username
      typeOfClient: $typeOfClient
      shippingAddress: $shippingAddress
      shippingCountry: $shippingCountry
      shippingState: $shippingState
      registrationType: $registrationType
      shippingCity: $shippingCity
      shippingPincode: $shippingPincode
      expiryDate: $expiryDate
      solution: $solution
      billingMode: $billingMode
      salesPersonId: $salesPersonId
      minimumTrackedDays: $minimumTrackedDays
      packetThreshold: $packetThreshold
      prorata: $prorata
    )
  }
`

const GET_ALL_PLANS = gql`
  query getAllPlans($partnerLoginId: Int!) {
    allPlans: getAllPlans(partnerLoginId: $partnerLoginId) {
      id
      planName
    }
  }
`

// Business name validation
const GET_CLIENT_NAME = gql`
  query checkClientName($businessname: String!, $id: Int) {
    checkClientName(clientName: $businessname, id: $id)
  }
`

// Business name validation
const GET_CONTACTNO = gql`
  query checkClientContactNumber($phoneno: String!, $id: Int) {
    checkClientContactNumber(contactNumber: $phoneno, id: $id)
  }
`

// Business email validation
const GET_EMAIL = gql`
  query checkClientEmail($email: String!, $id: Int) {
    checkClientEmail(email: $email, id: $id)
  }
`

// Business pan validation
const GET_PAN_NUMBER = gql`
  query checkClientPanNumber($pan: String!, $id: Int) {
    checkClientPanNumber(panNumber: $pan, id: $id)
  }
`

// Checking GST Number exist in DB or not
const GET_GST_NUMBER = gql`
  query checkClientGST($gst: String!) {
    checkClientGST(GST: $gst)
  }
`
// username validation
const GET_USERNAME = gql`
  query checkUsername($username: String!, $id: Int) {
    checkUsername(username: $username, loginId: $id)
  }
`

const GET_ALL_SALESPERSON = gql`
  query getAllSalesPerson($partnerLoginId: Int) {
    getAllSalesPerson(partnerLoginId: $partnerLoginId) {
      id
      name
    }
  }
`

const GET_COUNTRIES = gql`
  query {
    allCountries {
      country_id
      name
    }
  }
`
const GET_STATES_FOR_COUNTRY = gql`
  query getStatesByCountryId($countryId: Int!) {
    allStatesByCountryId(country_id: $countryId) {
      name
      zone_id
    }
  }
`

const GET_GST_INFO = gql`
  query getGstDetails($gstNumber: String!) {
    getGstDetails(gstNumber: $gstNumber) {
      status
      panNumber
      companyName
      address
      pinCode
    }
  }
`

const SOLUTION_TYPES = [
  {
    value: 'API',
    label: 'API'
  },
  {
    value: 'PORTAL',
    label: 'PORTAL'
  }
]
const TYPE_OF_CLIENT = [
  {
    value: 'REAL',
    label: 'COMMERCIAL'
  },
  {
    value: 'DEMO',
    label: 'NON-COMMERCIAL'
  }
]

const CUSTOMER_TYPES = [
  {
    value: 'International',
    label: 'International'
  },
  {
    value: 'Registered',
    label: 'Registered'
  },
  {
    value: 'Unregistered',
    label: 'Unregistered'
  }
]
const BILLING_MODES = [
  {
    value: 1,
    label: 'PREPAID'
  },
  {
    value: 2,
    label: 'POSTPAID'
  }
]

class EditCustomer extends Component {
  constructor(props) {
    super(props)
    this.loginId = parseInt(this.props.match.params.loginId, 10)
    let timezoneLists = require('timezone-list').getTimezones()
    const timezoneList = timezoneLists.map(timezone => ({
      value: timezone,
      label: timezone
    }))

    this.state = {
      clientId: '',
      companyName: '',
      username: '',
      person: '',
      password: '',
      clientType: '',
      registrationType: '',
      email: '',
      secondaryEmail: '',
      phoneno: '',
      secondaryContactNumber: '',
      address: '',
      // billingAddress2: '',
      city: '',
      state: '',
      shippingAddress: '',
      shippingCity: '',
      shippingPincode: '',
      country: '',
      shippingCountry: '',
      shippingState: '',
      pincode: '',
      pan: '',
      gst: '',
      isGstEdited: false,
      isGstInfoAvailable: true,
      plan: '',
      timezoneList: timezoneList,
      timezone: '',
      isEmailValid: true,
      isEmailValid2: true,
      isPhonenoValid: true,
      isPhonenoValid2: true,
      isAddressValid: true,
      isShippingAddressValid: true,
      isCityValid: true,
      isShippingCityValid: true,
      isChecked: false,
      isPinValid: true,
      isPanValid: true,
      isGSTValid: true,
      isUsernameValid: true,
      isNameValid: true,
      isContactpValid: true,
      isContactSValid: true,
      isPasswordValid: true,
      isUsernameUnique: true,
      isCancelConfDialogOpen: false,
      isSaveConfDialogOpen: false,
      response: false,
      clientLoginId: '',
      clientNameRes: '',
      emailRes: '',
      phonenoRes: '',
      usernameRes: '',
      panNoRes: '',
      typeOfClient: 'REAL',
      expiryDateTime: moment().add(1, 'week'),
      solution: '',
      prorata: 0,

      minimumTrackedDays: 0,
      packetThreshold: 0,
      billingMode: '',
      salesPerson: '',
      allSalesPerson: [],
      isStateChanged: false,
      // isShippingAddressChecked: false
      isShippingAddressChecked: false,
      isShippingPinvalid: true,
      gstErrorFieldText: ''
    }
  }

  getClients = async () => {
    const { data } = await this.props.client.query({
      query: GET_CLIENT,
      variables: {
        loginId: parseInt(this.loginId, 10)
      },
      fetchPolicy: 'network-only'
    })
    // console.log('clientDetails', data.clientDetail)
    // console.log(data.address)

    this.setDetails(data.clientDetail)
  }

  handleDateTimeChange = date =>
    this.setState({ expiryDateTime: date, isStateChanged: true })

  componentDidMount() {
    this.getClients()
    this.getAllSalesPersonDetails()
    console.log(this.state.address)
  }

  handleProrata = e => {
    this.setState({ [e.target.name]: e.target.value, isStateChanged: true })
  }

  setProrata = e => {
    this.setState({ minimumTrackedDays: 1, packetThreshold: 1 })
  }

  // handleCheckboxChange = e => {
  //   const name = e.target.name

  //   this.setState(prev => ({
  //     // isChecked: !prev.isChecked
  //     prorata: prev ? 0 : 1
  //   }))
  // }

  handleCheckboxChange = e => {
    this.state.prorata
      ? this.setState({ prorata: 0 })
      : this.setState({ prorata: 1 })
  }
  setDetails = clientDetail => {
    // console.log('details 1', clientDetail)
    this.setState({
      clientId: clientDetail.id,
      companyName: clientDetail.clientName.toUpperCase(),
      username: clientDetail.login.username,
      person: clientDetail.contactPerson,
      secondaryContactName: clientDetail.secondaryContactName,
      secondaryContactNumber: clientDetail.secondaryContactNumber,
      secondaryEmail: clientDetail.secondaryEmail,
      email: clientDetail.email,
      clientType: clientDetail.clientType,
      phoneno: clientDetail.contactNumber,
      address: clientDetail.address,
      shippingAddress: clientDetail.shippingAddress,
      shippingCity: clientDetail.shippingCity,
      shippingPincode: clientDetail.shippingPincode,
      city: clientDetail.city,
      state: clientDetail.state.zone_id,
      shippingState: clientDetail.shippingState
        ? clientDetail.shippingState.zone_id
        : null,
      country: clientDetail.country.country_id,
      shippingCountry: clientDetail.shippingCountry
        ? clientDetail.shippingCountry.country_id
        : null,
      pincode: clientDetail.pincode,
      pan: clientDetail.panNumber,
      plan: clientDetail.plan.id,
      timezone: clientDetail.timezone,
      prorata: clientDetail.prorata,
      minimumTrackedDays: clientDetail.minimumTrackedDays,
      packetThreshold: clientDetail.packetThreshold,
      gst: clientDetail.gst,
      clientLoginId: clientDetail.loginId,
      registrationType: clientDetail.registrationType,
      typeOfClient: clientDetail.type,
      expiryDateTime: clientDetail.expiryDate
        ? moment.unix(clientDetail.expiryDate)
        : this.state.expiryDateTime,
      solution: clientDetail.solution,
      billingMode: clientDetail.billingMode.id,
      salesPerson: clientDetail.salesPerson && clientDetail.salesPerson.id
    })
    // console.log('this.state', this.state.state)
  }

  handleSolutionChange = solutionType => {
    this.setState({
      isStateChanged: true
    })
    console.log('solution:', solutionType)
    if (!solutionType) {
      this.setState({ solution: '' })
    } else {
      this.setState({ solution: solutionType.value })
    }
  }

  hanldeBillingModeChange = billingMode => {
    this.setState({
      isStateChanged: true
    })
    console.log('biiling Mode', billingMode)
    if (!billingMode) {
      this.setState({ billingMode: '' })
    } else {
      this.setState({ billingMode: billingMode.value })
    }
  }

  getAllSalesPersonDetails = async () => {
    const fetchSalesPersonData = await this.props.client.query({
      query: GET_ALL_SALESPERSON,
      variables: {
        partnerLoginId: getLoginId()
      }
    })
    const {
      data: { getAllSalesPerson }
    } = fetchSalesPersonData
    const salesPersonsDetails = getAllSalesPerson.map(salesPerson => ({
      value: salesPerson.id,
      label: salesPerson.name
    }))
    // console.log('Edit customer getAllsataperson :', salesPersonsDetails)
    this.setState({ allSalesPerson: salesPersonsDetails })
  }

  handleSalesPersonChange = salesPerson => {
    this.setState({
      isStateChanged: true
    })
    console.log('salesPerson', salesPerson)
    if (!salesPerson) {
      this.setState({ salesPerson: '' })
    } else {
      this.setState({ salesPerson: salesPerson.value })
    }
  }

  handleInputChange = e => {
    this.setState({
      [e.target.name]: e.target.value,
      isStateChanged: true
    })
  }

  // handleCheckboxChange = e => {
  //   const name = e.target.name

  //   this.setState(prev => ({
  //     isChecked: !prev.isChecked
  //   }))
  // }
  handleCountryChange = country => {
    this.setState({
      isStateChanged: true
    })
    if (!country) {
      this.setState({ state: '', country: '' })
    } else {
      this.setState({
        state: '',
        country: country.value
      })
    }
  }

  handleShippingCountryChange = country => {
    this.setState({
      isStateChanged: true
    })
    if (!country) {
      this.setState({ shippingState: '', shippingCountry: '' })
    } else {
      this.setState({ shippingState: '', shippingCountry: country.value })
    }
  }

  handleStateChange = state => {
    // console.log(state, 'state')
    this.setState({
      isStateChanged: true
    })
    this.setState({ state: state && state.value })
  }

  handleShippingStateChange = state => {
    // console.log(state, 'state')
    this.setState({
      isStateChanged: true
    })
    this.setState({ shippingState: state && state.value })
  }

  handlePlanChange = plan => {
    this.setState({
      isStateChanged: true
    })
    if (!plan) {
      this.setState({ plan: '' })
    } else {
      this.setState({ plan: plan.value })
    }
  }
  handleTimezoneChange = timezone => {
    this.setState({
      isStateChanged: true
    })
    if (!timezone) {
      this.setState({ timezone: '' })
    } else {
      this.setState({ timezone: timezone.value })
    }
  }

  handleCustomerTypeChange = customer => {
    console.log('Customer', customer)
    if (!customer) {
      this.setState({ registrationType: '' })
    } else {
      this.setState({
        registrationType: customer.value,
        gst: '',
        pan: '',
        companyName: '',
        address: '',
        pincode: ''
      })
    }
  }
  checkNameValidity = client => async event => {
    const regex = new RegExp(
      /^(?!\s)(?!.*\s$)(?=.*[a-zA-Z0-9])[a-zA-Z0-9 '~?!]{5,32}$/
    )
    const { data } = await client.query({
      query: GET_CLIENT_NAME,
      variables: {
        businessname: this.state.name,
        id: parseInt(this.state.clientId, 10)
      }
    })
    this.setState({
      isNameValid:
        regex.test(this.state.name) &&
        this.state.name !== '' &&
        data.checkClientName === 'AVAILABLE'
    })
    if (regex.test(this.state.name) === false) {
      this.setState({
        clientNameRes:
          'Name can be characters or Number between 5-32 characters'
      })
    } else if (data.checkClientName !== 'AVAILABLE') {
      this.setState({ clientNameRes: 'Name already exist' })
    }
  }

  checkContactValidity = arg => {
    const regex = new RegExp(/^[a-zA-Z\s]{3,32}$/)
    if (arg === 'primary') {
      this.setState({
        isContactpValid:
          regex.test(this.state.person) && this.state.person !== ''
      })
    } else if (arg === 'secondary') {
      if (this.state.secondaryContactName !== '') {
        this.setState({
          isContactSValid: regex.test(this.state.secondaryContactName)
        })
      }
    }
  }

  checkPasswordValidity = () => {
    // const regex = new RegExp(/^[a-zA-Z0-9.\-_$@*!]{3,20}$/)
    const regex = new RegExp(/^[a-zA-Z0-9!@#$&()\\-`.+,/"]{3,20}$/)
    this.setState({
      isPasswordValid:
        this.state.password !== '' && regex.test(this.state.password)
    })

    // this.setState({
    //   isPasswordValid: this.state.password !== ''
    // })
  }

  checkPhonenoValidity = client => async event => {
    const regex = new RegExp(/^(\+91[-\s]?)?[0]?(91)?[1-9]\d{8,19}$/)
    const { data } = await client.query({
      query: GET_CONTACTNO,
      variables: {
        phoneno: this.state.phoneno,
        id: parseInt(this.state.clientId, 10)
      }
    })

    this.setState({
      isPhonenoValid:
        regex.test(this.state.phoneno) &&
        this.state.phoneno !== '' &&
        data.checkClientContactNumber === 'AVAILABLE'
    })

    if (regex.test(this.state.phoneno) === false) {
      this.setState({ phonenoRes: 'Invalid phone number' })
    } else if (data.checkClientContactNumber !== 'AVAILABLE') {
      this.setState({ phonenoRes: 'Phone number already exist' })
    }
  }

  checkPhoneNoValidity2 = client => async event => {
    const regex = new RegExp(/^(\+91[-\s]?)?[0]?(91)?[1-9]\d{8,19}$/)
    // const { data } = await client.query({
    //   query: GET_CONTACTNO,
    //   variables: {
    //     phoneno: this.state.secondaryContactNumber,
    //     id: parseInt(this.state.clientId, 10)
    //   }
    // })
    if (this.state.secondaryContactNumber !== '') {
      this.setState({
        isPhonenoValid2: regex.test(this.state.secondaryContactNumber)
        //  &&
        // data.checkClientContactNumber === 'AVAILABLE'
      })

      if (regex.test(this.state.secondaryContactNumber) === false) {
        this.setState({ phonenoRes2: 'Invalid phone number' })
      }
      // else if (data.checkClientContactNumber !== 'AVAILABLE') {
      //   this.setState({ phonenoRes2: 'Phone number already exist' })
      // }
    }
  }

  checkEmailValidity = client => async event => {
    const regex = new RegExp(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    )
    const { data } = await client.query({
      query: GET_EMAIL,
      variables: {
        email: this.state.email,
        id: parseInt(this.state.clientId, 10)
      }
    })
    this.setState({
      isEmailValid:
        regex.test(this.state.email) &&
        this.state.email !== '' &&
        data.checkClientEmail === 'AVAILABLE'
    })
    if (regex.test(this.state.email) === false) {
      this.setState({ emailRes: 'Invalid Email' })
    } else if (data.checkClientEmail !== 'AVAILABLE') {
      this.setState({ emailRes: 'Email already exist' })
    }
  }
  checkEmailValidity2 = client => async event => {
    const regex = new RegExp(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    )
    // const { data } = await client.query({
    //   query: GET_EMAIL,
    //   variables: {
    //     email: this.state.secondaryEmail,
    //     id: parseInt(this.state.clientId, 10)
    //   }
    // })
    if (this.state.secondaryEmail !== '') {
      this.setState({
        isEmailValid2: regex.test(this.state.secondaryEmail)
        // &&
        // data.checkClientEmail === 'AVAILABLE'
      })
      if (regex.test(this.state.secondaryEmail) === false) {
        this.setState({ emailRes2: 'Invalid Email' })
      }
      // else if (data.checkClientEmail !== 'AVAILABLE') {
      //   this.setState({ emailRes2: 'Email already exist' })
      // }
    }
  }
  checkAddressValidity = () => {
    // const regex = new RegExp(/^[a-zA-Z0-9\s#/,.'-]{3,300}$/)
    const regex = new RegExp(/^(.{5,200})$/)
    const regex2 = new RegExp(/^[^\s]+(\s+[^\s]+)*$/)
    this.setState({
      isAddressValid:
        regex.test(this.state.address) && regex2.test(this.state.address)
    })
  }

  checkShippingAddressValidity = () => {
    // const regex = new RegExp(/^[a-zA-Z0-9\s#/,.#'-]{3,300}$/)
    const regex = new RegExp(/^(.{5,200})$/)
    const regex2 = new RegExp(/^[^\s]+(\s+[^\s]+)*$/)
    this.setState({
      isShippingAddressValid:
        regex.test(this.state.shippingAddress) &&
        regex2.test(this.state.shippingAddress)
    })
  }

  checkCountryValidity = () =>
    this.setState({
      isCountryValid: this.state.country !== ''
    })

  // checkCityValidity = () => {
  //   // const regex = new RegExp(/^[a-zA-Z]+(?:[\s-][a-zA-Z]+)*$/)
  //   const regex = new RegExp(/^[a-zA-Z ]*$/)
  //   this.setState({
  //     isCityValid: regex.test(this.state.city) && this.state.city !== ''
  //   })
  // }
  checkCityValidity = arg => {
    const regex = new RegExp(/^[a-zA-Z]+(?:[\s-][a-zA-Z]+)*$/)

    if (arg === 'billing') {
      this.setState({
        isCityValid: regex.test(this.state.city) && this.state.city !== ''
      })
    } else if (arg === 'shipping') {
      this.setState({
        isShippingCityValid:
          regex.test(this.state.shippingCity) && this.state.city !== ''
      })
    }
  }

  checkPinValidity = () => {
    this.setState({ isPinValid: true })
    if (this.state.pincode !== null && this.state.pincode !== '') {
      const regex = new RegExp(/^[1-9][0-9]{5}$/)
      this.setState({
        isPinValid: regex.test(this.state.pincode)
      })
    }
  }
  checkPinValidity2 = () => {
    this.setState({ isShippingPinvalid: true })
    if (
      this.state.shippingPincode !== null &&
      this.state.shippingPincode !== ''
    ) {
      const regex = new RegExp(/^[1-9][0-9]{5}$/)
      this.setState({
        isShippingPinvalid: regex.test(this.state.shippingPincode)
      })
    }
  }

  checkPanValidity = client => async event => {
    this.setState({ isPanValid: true })
    if (this.state.pan !== null && this.state.pan !== '') {
      // const regex = new RegExp(/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/)
      const regex = new RegExp(/[A-Z]{5}[0-9]{4}[A-Z]{1}$/)
      const { data } = await client.query({
        query: GET_PAN_NUMBER,
        variables: {
          pan: this.state.pan,
          id: parseInt(this.state.clientId, 10)
        }
      })
      this.setState({
        isPanValid:
          regex.test(this.state.pan) &&
          this.state.pan !== '' &&
          data.checkClientPanNumber === 'AVAILABLE'
      })
      if (regex.test(this.state.pan) === false) {
        this.setState({ panNoRes: 'Invalid PAN Number(BLOCK letters only)' })
      } else if (data.checkClientPanNumber !== 'AVAILABLE') {
        this.setState({ panNoRes: 'PAN number already exist' })
      }
    }
  }

  checkGSTValidity = async gstNumber => {
    if (this.state.gst !== null && this.state.gst !== '') {
      // const regex = new RegExp(/\d{2}[A-Z]{5}\d{4}[A-Z]{1}\d[Z]{1}[A-Z\d]{1}/)
      const regex = new RegExp(
        /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/
      )
      const { data } = await this.props.client.query({
        query: GET_GST_NUMBER,
        variables: { gst: this.state.gst },
        fetchPolicy: 'network-only'
      })

      this.setState({
        isGSTExists: data.checkClientGST === 'AVAILABLE',
        isGstEdited: true,
        isGSTValid: regex.test(this.state.gst)
      })

      if (!this.state.isGSTValid) {
        this.setState({
          gstErrorFieldText: 'Invalid GST Number.'
        })
      }

      if (this.state.isGSTExists == false) {
        this.setState({ gstErrorFieldText: 'GST Number already registered.' })
      }

      if (this.state.isGSTValid && this.state.isGSTExists) {
        this.setState({
          gstErrorFieldText: '',
          pan: '',
          companyName: '',
          address: '',
          pincode: ''
        })

        await this.getGstInfo(gstNumber)
        if (!this.state.isGstInfoAvailable) {
          this.setState({ gstErrorFieldText: 'Invalid GST Number.' })
        }
      } else {
        this.setState({
          pan: '',
          companyName: '',
          address: '',
          pincode: ''
        })
      }
    } else {
      this.setState({
        pan: '',
        companyName: '',
        address: '',
        pincode: ''
      })
    }
  }

  checkUsernameValidity = client => async event => {
    const regex = new RegExp(/^[a-zA-Z0-9.\-_$@*!]{5,32}$/)
    const { data } = await client.query({
      query: GET_USERNAME,
      variables: {
        username: this.state.username,
        id: parseInt(this.state.clientLoginId, 10)
      }
    })
    // console.log('check', data, regex.test(this.state.username))
    this.setState({
      isUsernameUnique: data.checkUsername === 'AVAILABLE',
      isUsernameValid:
        regex.test(this.state.username) &&
        this.state.username !== '' &&
        data.checkUsername === 'AVAILABLE'
    })
    if (regex.test(this.state.username) === false) {
      this.setState({
        usernameRes:
          'Username Can be character number special chatcters(-_$@*!) without blank space between 5-32 charcters'
      })
    } else if (data.checkUsername !== 'AVAILABLE') {
      this.setState({
        usernameRes: 'Username already exist'
      })
    }
  }

  handleCancelClick = e => {
    if (this.state.isStateChanged) {
      this.setState({ isCancelConfDialogOpen: true })
    } else {
      this.cancelForm()
    }
  }

  handleSaveClick = e => {
    this.setState({ isSaveConfDialogOpen: true })
  }

  handleCancelNegativeResponse = e => {
    this.setState({ isCancelConfDialogOpen: false })
  }

  handleSaveNegativeResponse = e => {
    this.setState({ isSaveConfDialogOpen: false })
  }

  handleShippingAddressCheckbox = () => {
    this.setState({
      isShippingAddressValid: true,
      isShippingCityValid: true,
      isShippingPinvalid: true,
      shippingAddress: '',
      shippingCity: '',
      shippingPincode: '',
      shippingCountry: '',
      shippingState: ''
    })
    this.setState(
      {
        isShippingAddressChecked: !this.state.isShippingAddressChecked
      },
      () => {
        if (this.state.isShippingAddressChecked === true) {
          this.setState({
            shippingAddress: this.state.address,
            shippingCity: this.state.city,
            shippingPincode: this.state.pincode,
            shippingCountry: this.state.country,
            shippingState: this.state.state
          })
        } else {
          this.setState({
            shippingAddress: '',
            shippingCity: '',
            shippingPincode: '',
            shippingCountry: '',
            shippingState: ''
          })
        }
      }
    )
  }

  submitForm = client => async e => {
    e.preventDefault()

    let variables = {
      id: parseInt(this.state.clientId, 10),
      clientName: this.state.companyName,
      login_id: parseInt(this.loginId, 10),
      email: this.state.email,
      contactPerson: this.state.person,
      contactNumber: this.state.phoneno,
      secondaryEmail: this.state.secondaryEmail,
      secondaryContactName: this.state.secondaryContactName,
      secondaryContactNumber: this.state.secondaryContactNumber,
      address: this.state.address,
      shippingAddress: this.state.shippingAddress,
      shippingCountry: this.state.shippingCountry,
      shippingState: this.state.shippingState,
      shippingCity: this.state.shippingCity,
      shippingPincode: parseInt(this.state.shippingPincode, 10),
      city: this.state.city,
      state_id: parseInt(this.state.state, 10),
      country_id: parseInt(this.state.country, 10),
      pincode: parseInt(this.state.pincode, 10),
      panNumber: this.state.pan,
      clientType: this.state.clientType,
      registrationType: this.state.registrationType,
      subscriptionPlan: 'prepaid',
      periodicity: 1,
      status: 1,
      partnerLoginId: getLoginId(),
      plan: parseInt(this.state.plan, 10),
      timezone: this.state.timezone,
      gst: this.state.gst,
      username: this.state.username,
      typeOfClient: this.state.typeOfClient,
      solution: this.state.solution,
      billingMode: this.state.billingMode,
      prorata: this.state.prorata,
      packetThreshold: parseInt(this.state.packetThreshold, 10),
      salesPersonId: this.state.salesPerson,
      minimumTrackedDays: parseInt(this.state.minimumTrackedDays, 10)
    }
    // console.log(variables.shippingAddress)
    // console.log(variables.address)

    if (this.state.typeOfClient === 'NON-COMMERCIAL') {
      variables['expiryDate'] = moment(this.state.expiryDateTime)
        .unix()
        .toString()
    }

    const { data, errors } = await client.mutate({
      mutation: UPDATE_CLIENT,
      variables,
      errorPolicy: 'all',
      refetchQueries: ['allClientDetails']
    })

    if (data) {
      this.props.openSnackbar('Updated Successfully')
      this.setState({
        clientId: '',
        companyName: '',
        username: '',
        person: '',
        secondaryContactNumber: '',
        secondaryEmail: '',
        secondaryContactName: '',
        password: '',
        clientType: '',
        email: '',
        phoneno: '',
        address: '',
        // billingAddress2: '',
        // shippingAddress2: '',
        city: '',
        state: '',
        country: '',
        shippingState: '',
        shippingCountry: '',
        pincode: '',
        shippingAddress: '',
        shippingCity: '',
        shippingPincode: '',
        pan: '',
        gst: '',
        plan: '',
        timezone: '',
        prorata: 0,
        packetThreshold: 0,
        minimumTrackedDays: 0,
        typeOfClient: 'REAL',
        expiryDateTime: moment().add(1, 'week')
      })
      this.props.history.push({
        pathname: '/home/customers'
      })
    } else {
      this.props.openSnackbar(errors[0].message)
    }
  }

  cancelForm = e => {
    // this.setState({
    //   clientId: '',
    //   companyName: '',
    //   username: '',
    //   person: '',
    //   password: '',
    //   email: '',
    //   phoneno: '',
    //   address: '',
    //   billingAddress2: '',
    //   city: '',
    //   state: '',
    //   country: '',
    //   pincode: '',
    //   pan: '',
    //   gst: '',
    //   plan: '',
    //   timezone: '',
    //   typeOfClient: 'REAL',
    //   expiryDateTime: moment().add(1, 'week')
    // })
    this.props.history.goBack()
  }

  handleTypeChange = e => {
    const { value } = e.target
    console.log('typeof client :', value)
    this.setState({
      typeOfClient: e.target.value,
      isStateChanged: true
    })
    if (value === 'DEMO') {
      this.setState({
        expiryDateTime: moment().add(1, 'month'),
        isStateChanged: true
      })
    } else {
      this.setState({
        expiryDateTime: moment().add(1, 'week'),
        isStateChanged: true
      })
    }
  }

  getGstInfo = async gstNumber => {
    const fetchGstData = await this.props.client.query({
      query: GET_GST_INFO,
      variables: {
        gstNumber: gstNumber
      }
    })

    this.setState({
      isGstInfoAvailable: fetchGstData.data.getGstDetails.status === 'SUCCESS',
      pan:
        fetchGstData.data.getGstDetails.panNumber != null
          ? fetchGstData.data.getGstDetails.panNumber
          : null,
      companyName:
        fetchGstData.data.getGstDetails.companyName != null
          ? fetchGstData.data.getGstDetails.companyName
          : null,
      address:
        fetchGstData.data.getGstDetails.address != null
          ? fetchGstData.data.getGstDetails.address
          : null,
      pincode:
        fetchGstData.data.getGstDetails.pinCode != null
          ? fetchGstData.data.getGstDetails.pinCode
          : null
    })
  }

  render() {
    const {
      companyName,
      username,
      person,
      clientType,
      registrationType,
      secondaryContactName,
      secondaryContactNumber,
      secondaryEmail,
      email,
      phoneno,
      address,
      // billingAddress2,
      // shippingAddress2,
      shippingAddress,
      shippingCity,
      shippingPincode,
      city,
      state,
      country,
      shippingCountry,
      shippingState,
      pincode,
      pan,
      gst,
      isGstEdited,
      gstErrorFieldText,
      plan,
      typeOfClient,
      solution,
      billingMode,
      prorata,
      minimumTrackedDays,
      packetThreshold,
      salesPerson,
      allSalesPerson
    } = this.state

    const { classes } = this.props

    return (
      <Query
        query={GET_ALL_PLANS} // Fetch Billing Modes here
        variables={{
          partnerLoginId: getLoginId()
        }}
        fetchPolicy="network-only"
      >
        {({ loading, error, data: { allPlans } }) => {
          if (loading) return <Loader />
          if (error) return `Error!: ${error}`

          const plans = allPlans.map(plan => ({
            value: plan.id,
            label: plan.planName
          }))

          return (
            <div className={classes.root}>
              <ConfirmationalDialog
                isDialogOpen={this.state.isSaveConfDialogOpen}
                dialogMessage={
                  "Are you sure you want to Save this customer's details?"
                }
                negativeResponseHandler={this.handleSaveNegativeResponse}
                positiveResponseHandler={this.submitForm(this.props.client)}
              />
              <ConfirmationalDialog
                isDialogOpen={this.state.isCancelConfDialogOpen}
                dialogMessage={
                  'Are you sure you want to Cancel new customer creation?'
                }
                negativeResponseHandler={this.handleCancelNegativeResponse}
                positiveResponseHandler={this.cancelForm}
              />
              <Grid container spacing={16}>
                <Grid item xs={12} justify="flex-start">
                  <Button
                    variant="outlined"
                    color="secondary"
                    className={classes.button}
                    onClick={this.handleCancelClick}
                  >
                    <ArrowBackIcon />
                  </Button>
                </Grid>
                <Grid item xs={12}>
                  <Card style={{ paddingBottom: '75px' }}>
                    <CardHeader
                      title="Edit Customer"
                      subheader="All fields marked with (*) are mandatory"
                      subheaderTypographyProps={{
                        className: classes.italicizedText
                      }}
                    />
                    <CardContent>
                      <Grid container spacing={16}>
                        {/* Customer Type */}
                        <Grid item xs={12} md={6}>
                          <FormGroup className="form-input">
                            <Select
                              options={CUSTOMER_TYPES}
                              value={registrationType}
                              onChange={this.handleCustomerTypeChange}
                              placeholder="Customer Type*"
                            />
                          </FormGroup>
                        </Grid>
                        {registrationType === 'Registered' && (
                          <Grid item xs={12} md={6}>
                            <FormGroup className="form-input">
                              <TextField
                                name="gst"
                                value={gst}
                                type="text"
                                onChange={this.handleInputChange}
                                label="GST"
                                required
                                error={!this.state.isGSTValid}
                                onBlur={() =>
                                  this.checkGSTValidity(this.state.gst)
                                }
                              />
                              <FormHelperText
                                id="name-error-text"
                                className="Error_msg"
                              >
                                {gstErrorFieldText}
                              </FormHelperText>
                            </FormGroup>
                          </Grid>
                        )}
                        {(registrationType === 'Registered' ||
                          registrationType === 'Unegistered') && (
                          <Grid item xs={12} md={6}>
                            <FormGroup className="form-input">
                              <TextField
                                name="pan"
                                value={pan}
                                type="text"
                                onChange={this.handleInputChange}
                                label="PAN"
                                required
                                disabled
                                error={!this.state.isPanValid}
                                onBlur={this.checkPanValidity(
                                  this.props.client
                                )}
                              />
                              <FormHelperText
                                id="name-error-text"
                                className="Error_msg"
                              >
                                {/* {this.state.pan.length === 10
                                  ? ''
                                  : 'Pan must have 10 characters'} */}
                                {this.state.isPanValid
                                  ? ''
                                  : this.state.panNoRes}
                              </FormHelperText>
                            </FormGroup>
                          </Grid>
                        )}
                        {/* <Grid item xs={12} md={6}>
                          <FormControl>
                            <RadioGroup
                              aria-label="position"
                              name="position"
                              value={typeOfClient}
                              onChange={this.handleTypeChange}
                              row
                            >
                              <FormControlLabel
                                value="REAL"
                                control={<Radio color="primary" />}
                                label="Billable"
                                labelPlacement="end"
                              />
                              <FormControlLabel
                                value="DEMO"
                                control={<Radio color="primary" />}
                                label="Non-Billablione"
                                labelPlacement="end"
                              />
                            </RadioGroup>
                          </FormControl>
                        </Grid>
                        {typeOfClient === 'DEMO' && (
                          <Grid item xs={12} md={6}>
                            <DateTimePicker
                              label="Expiry Date &amp; Time" // disabled={typeOfClient === 'REAL'}
                              value={this.state.expiryDateTime}
                              onChange={this.handleDateTimeChange}
                              inputProps={{ name: 'expiryDateTime' }}
                            />
                          </Grid>
                        )} */}

                        {/* <Grid item xs={12} md={6}>
                          <FormGroup className="form-input">
                            <Select
                              options={TYPE_OF_CLIENT}
                              value={typeOfClient}
                              onChange={this.handleTypeChange}
                              placeholder="Type Of Client"
                            />
                          </FormGroup>
                        </Grid> */}
                        <Grid item xs={12} md={6}>
                          <FormGroup className="form-input">
                            <Select
                              options={TYPE_OF_CLIENT}
                              value={typeOfClient}
                              placeholder="Type of Client"
                              disabled
                            />
                          </FormGroup>
                        </Grid>

                        {/* {typeOfClient.value === 'NON-COMMERCIAL' && (
                          <Grid item xs={12} md={6}>
                            <DateTimePicker
                              label="Expiry Date &amp; Time 11"
                              // disabled={typeOfClient === 'REAL'}
                              value={this.state.expiryDateTime}
                              onChange={this.handleDateTimeChange}
                              inputProps={{
                                name: 'expiryDateTime'
                              }}
                            />
                          </Grid>
                        )} */}

                        {/* depending on registered and unregistered the gst and pan are displayed */}
                        {/* {customerType === 'REGISTERED' && (
                          <Grid item xs={12} md={6}>
                            <FormGroup className="form-input">
                              <TextField
                                name="gst"
                                value={gst}
                                type="text"
                                onChange={this.handleInputChange}
                                label="GST"
                                required
                                error={!this.state.isGSTValid}
                                onBlur={this.checkGSTValidity}
                              />
                              <FormHelperText
                                id="name-error-text"
                                className="Error_msg"
                              >
                                {this.state.isGSTValid ? '' : 'Invalid GST'}
                              </FormHelperText>
                            </FormGroup>
                          </Grid>
                        )}

                        {(customerType === 'REGISTERED' ||
                          customerType === 'UNREGISTERED') && (
                          <Grid item xs={12} md={6}>
                            <FormGroup className="form-input">
                              <TextField
                                name="pan"
                                value={pan}
                                type="text"
                                onChange={this.handleInputChange}
                                label="PAN"
                                required
                                error={!this.state.isPanValid}
                                onBlur={this.checkPanValidity}
                              />
                              <FormHelperText
                                id="name-error-text"
                                className="Error_msg"
                              >
                                {this.state.isGSTValid ? '' : 'Invalid PAN'}
                              </FormHelperText>
                            </FormGroup>
                          </Grid>
                        )} */}

                        <Grid item xs={12} md={12}>
                          <FormGroup className="form-input">
                            <TextField
                              name="companyName"
                              value={companyName}
                              type="text"
                              onChange={this.handleInputChange}
                              onInput={e =>
                                (e.target.value = (
                                  '' + e.target.value
                                ).toUpperCase())
                              }
                              required
                              disabled={
                                this.state.registrationType == 'Registered'
                              }
                              label="Company Name"
                            />
                          </FormGroup>
                        </Grid>

                        <Grid item xs={12} md={6}>
                          <FormGroup className="form-input">
                            <Select
                              options={SOLUTION_TYPES}
                              value={solution}
                              onChange={this.handleSolutionChange}
                              placeholder="Select Solution*"
                            />
                          </FormGroup>
                        </Grid>

                        <Grid item xs={12} md={6}>
                          <FormGroup className="form-input">
                            <Select
                              options={plans}
                              value={plan}
                              onChange={this.handlePlanChange}
                              placeholder="Select Plan *"
                            />
                          </FormGroup>
                        </Grid>

                        <Grid item xs={12} md={6}>
                          <FormGroup className="form-input">
                            <Select
                              options={this.state.timezoneList}
                              value={this.state.timezone}
                              onChange={this.handleTimezoneChange}
                              placeholder="Select Time Zone"
                            />
                          </FormGroup>
                        </Grid>

                        {getLoginId() === 2 && (
                          <Grid item xs={12} md={6}>
                            <FormGroup className="form-input">
                              <Select
                                options={allSalesPerson}
                                value={salesPerson}
                                onChange={this.handleSalesPersonChange}
                                placeholder="Select Sales Person*"
                              />
                            </FormGroup>
                          </Grid>
                        )}

                        {/* Full name - not present */}
                        {/* <Grid item xs={12} md={6}>
                          <FormGroup className="form-input">
                            <TextField
                              name="name"
                              value={name}
                              type="text"
                              onChange={this.handleInputChange}
                              label="Full Name"
                              required
                              error={!this.state.isNameValid}
                              onBlur={this.checkNameValidity(this.props.client)}
                            />
                            <FormHelperText
                              id="name-error-text"
                              className="Error_msg"
                            >
                              {this.state.isNameValid
                                ? ''
                                : this.state.clientNameRes}
                            </FormHelperText>
                          </FormGroup>
                        </Grid> */}
                        <Grid item xs={12} md={6}>
                          <FormGroup className="form-input">
                            <TextField
                              name="username"
                              value={username}
                              type="text"
                              // onChange={this.handleInputChange}
                              label="Username"
                              required
                              onBlur={this.checkUsernameValidity(
                                this.props.client
                              )}
                            />
                            <FormHelperText
                              id="name-error-text"
                              className="Error_msg"
                            >
                              {!this.state.isUsernameValid
                                ? this.state.usernameRes
                                : ''}
                            </FormHelperText>
                          </FormGroup>
                        </Grid>

                        <Grid item xs={12} md={6}>
                          <FormGroup className="form-input">
                            <TextField
                              name="password"
                              value="password"
                              type="password"
                              onChange={this.handleInputChange}
                              label="Password"
                              disabled
                            />
                          </FormGroup>
                        </Grid>
                        <Grid item xs={12} md={12}>
                          {/* <FormGroup className="form-input" display="flex"> */}
                          {/* <label> */}
                          <Checkbox
                            name="prorata"
                            value={prorata}
                            checked={prorata}
                            onChange={this.setProrata}
                            onClick={this.handleCheckboxChange}
                          />
                          <span style={{ fontSize: '20px' }}>
                            Prorata Billing
                          </span>
                          {/* </label> */}
                          {/* </FormGroup> */}
                        </Grid>
                        {this.state.prorata ? (
                          <Grid item xs={12} md={6}>
                            <FormGroup className="form-input">
                              <TextField
                                name="minimumTrackedDays"
                                value={minimumTrackedDays}
                                type="text"
                                onChange={this.handleProrata}
                                label="Minimum Tracking Days"
                                required
                              />
                            </FormGroup>
                          </Grid>
                        ) : null}
                        {this.state.prorata ? (
                          <Grid item xs={12} md={6}>
                            <FormGroup className="form-input">
                              <TextField
                                name="packetThreshold"
                                value={packetThreshold}
                                type="text"
                                onChange={this.handleProrata}
                                label="Packets per Day"
                                required
                              />
                            </FormGroup>
                          </Grid>
                        ) : null}
                        {/* handlng checkbox change */}
                        {/* {this.state.isChecked && (
                          <Grid item xs={12} md={6}>
                            <FormGroup className="form-input">
                              <TextField
                                name="packetsPerDay"
                                value={packetsPerDay}
                                type="text"
                                onChange={this.handleProrata}
                                label="Packets per Day"
                                required
                              />
                            </FormGroup>
                          </Grid>
                        )}
                        {this.state.isChecked && (
                          <Grid item xs={12} md={6}>
                            <FormGroup className="form-input">
                              <TextField
                                name="miniumTrackingDays"
                                value={miniumTrackingDays}
                                type="text"
                                onChange={this.handleProrata}
                                label="Minium Tracking Days"
                                required
                              />
                            </FormGroup>
                          </Grid>
                        )} */}
                        <Grid item xs={12} md={12}>
                          <p style={{ fontSize: '24px' }}>Contact Info</p>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <FormGroup className="form-input">
                            <TextField
                              name="person"
                              value={person}
                              type="text"
                              onChange={this.handleInputChange}
                              label="Primary Contact Person"
                              required
                              error={!this.state.isContactpValid}
                              onBlur={() => {
                                this.checkContactValidity('primary')
                              }}
                            />
                            <FormHelperText
                              id="name-error-text"
                              className="Error_msg"
                            >
                              {this.state.isContactpValid
                                ? ''
                                : 'Only Alphabets allowed, between 3 to 32 characters'}
                            </FormHelperText>
                          </FormGroup>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <FormGroup className="form-input">
                            <TextField
                              name="secondaryContactName"
                              value={secondaryContactName || ''}
                              type="text"
                              onChange={this.handleInputChange}
                              label="Secondary Contact Person"
                              error={!this.state.isContactSValid}
                              onBlur={() => {
                                this.checkContactValidity('secondary')
                              }}
                            />
                            <FormHelperText
                              id="name-error-text"
                              className="Error_msg"
                            >
                              {this.state.isContactSValid
                                ? ''
                                : 'Only Alphabets allowed, between 3 to 32 characters'}
                            </FormHelperText>
                          </FormGroup>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <FormGroup className="form-input">
                            <TextField
                              name="email"
                              value={email || ''}
                              type="text"
                              onChange={this.handleInputChange}
                              label="Primary Email"
                              required
                              error={!this.state.isEmailValid}
                              onBlur={this.checkEmailValidity(
                                this.props.client
                              )}
                            />
                            <FormHelperText
                              id="name-error-text"
                              className="Error_msg"
                            >
                              {this.state.isEmailValid
                                ? ''
                                : this.state.emailRes}
                            </FormHelperText>
                          </FormGroup>
                        </Grid>

                        <Grid item xs={12} md={6}>
                          <FormGroup className="form-input">
                            <TextField
                              name="secondaryEmail"
                              value={secondaryEmail || ''}
                              type="text"
                              onChange={this.handleInputChange}
                              label="Secondary Email"
                              error={!this.state.isEmailValid2}
                              onBlur={this.checkEmailValidity2(
                                this.props.client
                              )}
                            />
                            <FormHelperText
                              id="name-error-text"
                              className="Error_msg"
                            >
                              {this.state.isEmailValid2
                                ? ''
                                : this.state.emailRes2}
                            </FormHelperText>
                          </FormGroup>
                        </Grid>

                        <Grid item xs={12} md={6}>
                          <FormGroup className="form-input">
                            <TextField
                              name="phoneno"
                              value={phoneno}
                              type="text"
                              onChange={this.handleInputChange}
                              label="Primary Phone Number"
                              required
                              error={!this.state.isPhonenoValid}
                              onBlur={this.checkPhonenoValidity(
                                this.props.client
                              )}
                            />
                            <FormHelperText
                              id="name-error-text"
                              className="Error_msg"
                            >
                              {this.state.isPhonenoValid
                                ? ''
                                : this.state.phonenoRes}
                            </FormHelperText>
                          </FormGroup>
                        </Grid>
                        {/* Secondary Phone number */}
                        <Grid item xs={12} md={6}>
                          <FormGroup className="form-input">
                            <TextField
                              name="secondaryContactNumber"
                              value={secondaryContactNumber || ''}
                              type="text"
                              onChange={this.handleInputChange}
                              label="Secondary Phone Number"
                              error={!this.state.isPhonenoValid2}
                              onBlur={this.checkPhoneNoValidity2(
                                this.props.client
                              )}
                            />
                            <FormHelperText
                              id="name-error-text"
                              className="Error_msg"
                            >
                              {this.state.isPhonenoValid2
                                ? ''
                                : 'Invalid phone Number'}
                            </FormHelperText>
                          </FormGroup>
                        </Grid>

                        {/* Billing mode, removed */}
                        <Grid item xs={12} md={6}>
                          <FormGroup className="form-input">
                            <Select
                              disabled={true}
                              options={BILLING_MODES}
                              value={billingMode}
                              onChange={this.hanldeBillingModeChange}
                              placeholder="Select Billing Mode*"
                            />
                          </FormGroup>
                        </Grid>

                        <Grid item xs={12} md={12}>
                          <p style={{ fontSize: '24px' }}>Billing Address</p>
                        </Grid>
                        {/* billing address */}
                        <Grid item xs={12} md={6}>
                          <FormGroup className="form-input">
                            <TextField
                              name="address"
                              value={address}
                              type="text"
                              onChange={this.handleInputChange}
                              label="Address Line 1"
                              required
                              error={!this.state.isAddressValid}
                              onBlur={this.checkAddressValidity}
                            />
                            <FormHelperText
                              id="name-error-text"
                              className="Error_msg"
                            >
                              {this.state.isAddressValid
                                ? ''
                                : 'Address should be between 5 to 200 characters without spaces at Start and End.'}
                            </FormHelperText>
                          </FormGroup>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          {/* <FormGroup className="form-input">
                            <TextField
                              name="billingAddress2"
                              value={billingAddress2}
                              type="text"
                              onChange={this.handleInputChange}
                              label="Address Line 2"
                              required
                              error={!this.state.isAddressValid}
                              onBlur={this.checkAddressValidity2}
                            />
                          </FormGroup> */}
                        </Grid>

                        <Grid item xs={6}>
                          <FormGroup className="form-input">
                            <Query query={GET_COUNTRIES}>
                              {({ loading, error, data: { allCountries } }) => {
                                if (loading) return 'Loading...'
                                if (error) return `Error!: ${error}`

                                const sortedCountries = allCountries.map(
                                  country => ({
                                    value: country.country_id,
                                    label: country.name
                                  })
                                )

                                return (
                                  <div>
                                    <Select
                                      // classes={classes}
                                      options={sortedCountries}
                                      // components={components}
                                      value={country}
                                      onChange={this.handleCountryChange}
                                      placeholder="Select Country *"
                                    />
                                  </div>
                                )
                              }}
                            </Query>
                          </FormGroup>
                        </Grid>
                        {this.state.country && (
                          <Grid item xs={12} md={6}>
                            <FormGroup className="form-input">
                              <Query
                                query={GET_STATES_FOR_COUNTRY}
                                variables={{
                                  countryId: country
                                }}
                              >
                                {({
                                  loading,
                                  error,
                                  data: { allStatesByCountryId }
                                }) => {
                                  if (loading) return 'Loading...'
                                  if (error) return `Error: ${error}`

                                  const allStates = allStatesByCountryId.map(
                                    s => {
                                      return {
                                        value: s.zone_id,
                                        label: s.name
                                      }
                                    }
                                  )

                                  if (allStates.length > 0) {
                                    return (
                                      <Select
                                        options={allStates}
                                        value={state}
                                        onChange={this.handleStateChange}
                                        placeholder="Select State *"
                                      />
                                    )
                                  } else {
                                    return (
                                      <TextField
                                        value="No States in this Country"
                                        type="text"
                                      />
                                    )
                                  }
                                }}
                              </Query>
                            </FormGroup>
                          </Grid>
                        )}

                        <Grid item xs={12} md={6}>
                          <FormGroup className="form-input">
                            <TextField
                              name="city"
                              value={city}
                              type="text"
                              onChange={this.handleInputChange}
                              label="City"
                              required
                              error={!this.state.isCityValid}
                              onBlur={() => {
                                this.checkCityValidity('billing')
                              }}
                            />
                            <FormHelperText
                              id="name-error-text"
                              className="Error_msg"
                            >
                              {this.state.isCityValid
                                ? ''
                                : 'Invalid City Name'}
                            </FormHelperText>
                          </FormGroup>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <FormGroup className="form-input">
                            <TextField
                              name="pincode"
                              value={pincode}
                              type="text"
                              onChange={this.handleInputChange}
                              label="Pin"
                              required
                              error={!this.state.isPinValid}
                              onBlur={this.checkPinValidity}
                            />
                            <FormHelperText
                              id="name-error-text"
                              className="Error_msg"
                            >
                              {this.state.isPinValid ? '' : 'Invalid Pin'}
                            </FormHelperText>
                          </FormGroup>
                        </Grid>
                        <Grid item xs={12} md={12}>
                          <p style={{ fontSize: '24px' }}>Shipping Address</p>
                        </Grid>
                        <Grid item xs={12} md={12}>
                          {/* <FormGroup className="form-input" display="flex"> */}
                          {/* <label> */}
                          <Checkbox
                            name="shipping"
                            checked={this.state.isShippingAddressChecked}
                            onClick={this.handleShippingAddressCheckbox}
                          />
                          <span style={{ fontSize: '15px' }}>
                            Same as billing
                          </span>
                          {/* </label> */}
                          {/* </FormGroup> */}
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <FormGroup className="form-input">
                            <TextField
                              name="shippingAddress"
                              // value={
                              //   this.state.shipping
                              //     ? address
                              //     : shippingAddress
                              // }
                              value={shippingAddress}
                              type="text"
                              onChange={this.handleInputChange}
                              label="Address Line 1"
                              required
                              error={!this.state.isShippingAddressValid}
                              onBlur={this.checkShippingAddressValidity}
                            />
                            <FormHelperText
                              id="name-error-text"
                              className="Error_msg"
                            >
                              {this.state.isShippingAddressValid
                                ? ''
                                : 'Shipping Address should be between 5 to 200 characters without spaces at Start and End.'}
                            </FormHelperText>
                          </FormGroup>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          {/* <FormGroup className="form-input">
                            <TextField
                              name="shippingAddress2"
                              // value={
                              //   this.state.shipping
                              //     ? billingAddress2
                              //     : shippingAddres2
                              // }
                              type="text"
                              onChange={this.handleInputChange}
                              label="Address Line 2"
                              required
                              error={!this.state.isAddressValid}
                              onBlur={this.checkAddressValidity2}
                            />
                          </FormGroup> */}
                        </Grid>

                        <Grid item xs={6}>
                          <FormGroup className="form-input">
                            <Query query={GET_COUNTRIES}>
                              {({ loading, error, data: { allCountries } }) => {
                                if (loading) return 'Loading...'
                                if (error) return `Error!: ${error}`

                                const sortedCountries = allCountries.map(
                                  country => ({
                                    value: country.country_id,
                                    label: country.name
                                  })
                                )

                                return (
                                  <div>
                                    <Select
                                      // classes={classes}
                                      options={sortedCountries}
                                      // components={components}
                                      value={shippingCountry}
                                      onChange={
                                        this.handleShippingCountryChange
                                      }
                                      placeholder="Select Country *"
                                    />
                                  </div>
                                )
                              }}
                            </Query>
                          </FormGroup>
                        </Grid>
                        {this.state.shippingCountry && (
                          <Grid item xs={12} md={6}>
                            <FormGroup className="form-input">
                              <Query
                                query={GET_STATES_FOR_COUNTRY}
                                variables={{
                                  countryId: shippingCountry
                                }}
                              >
                                {({
                                  loading,
                                  error,
                                  data: { allStatesByCountryId }
                                }) => {
                                  if (loading) return 'Loading...'
                                  if (error) return `Error: ${error}`

                                  const allStates = allStatesByCountryId.map(
                                    s => {
                                      return {
                                        value: s.zone_id,
                                        label: s.name
                                      }
                                    }
                                  )

                                  if (allStates.length > 0) {
                                    return (
                                      <Select
                                        options={allStates}
                                        value={shippingState}
                                        onChange={
                                          this.handleShippingStateChange
                                        }
                                        placeholder="Select State *"
                                      />
                                    )
                                  } else {
                                    return (
                                      <TextField
                                        value="No States in this Country"
                                        type="text"
                                      />
                                    )
                                  }
                                }}
                              </Query>
                            </FormGroup>
                          </Grid>
                        )}

                        <Grid item xs={12} md={6}>
                          <FormGroup className="form-input">
                            <TextField
                              name="shippingCity"
                              // value={this.state.shipping ? city : city2}
                              type="text"
                              onChange={this.handleInputChange}
                              label="City"
                              value={shippingCity}
                              required
                              error={!this.state.isShippingCityValid}
                              onBlur={() => {
                                this.checkCityValidity('shipping')
                              }}
                            />
                            <FormHelperText
                              id="name-error-text"
                              className="Error_msg"
                            >
                              {this.state.isShippingCityValid
                                ? ''
                                : 'Invalid City Name'}
                            </FormHelperText>
                          </FormGroup>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <FormGroup className="form-input">
                            <TextField
                              name="shippingPincode"
                              // value={this.state.shipping ? pincode : pincode2}
                              value={shippingPincode}
                              type="text"
                              onChange={this.handleInputChange}
                              label="Pin"
                              required
                              error={!this.state.isShippingPinvalid}
                              onBlur={this.checkPinValidity2}
                            />
                            <FormHelperText
                              id="name-error-text"
                              className="Error_msg"
                            >
                              {this.state.isShippingPinvalid
                                ? ''
                                : 'Invalid Pin'}
                            </FormHelperText>
                          </FormGroup>
                        </Grid>
                        {/* <Grid item xs={12}>
                          <CustomTabs
                            address={address}
                            billingAddress2={billingAddress2}
                            city={city}
                            state={state}
                            country={country}
                            pincode={pincode}
                            pan={pan}
                            gst={gst}
                            handleInputChange={this.handleInputChange}
                            handleCountryChange={this.handleCountryChange}
                            handleStateChange={this.handleStateChange}
                            checkAddressValidity={this.checkAddressValidity}
                            checkCityValidity={this.checkCityValidity}
                            checkPinValidity={this.checkPinValidity}
                            checkPanValidity={this.checkPanValidity(
                              this.props.client
                            )}
                            checkGSTValidity={this.checkGSTValidity}
                            isAddressValid={this.state.isAddressValid}
                            isCityValid={this.state.isCityValid}
                            isPinValid={this.state.isPinValid}
                            isPanValid={this.state.isPanValid}
                            isGSTValid={this.state.isGSTValid}
                            panNoRes={this.state.panNoRes}
                          />
                        </Grid> */}
                      </Grid>
                    </CardContent>
                    <CardActions
                      style={{ paddingTop: '25px', paddingLeft: '25px' }}
                    >
                      <Button
                        color="secondary"
                        variant="contained"
                        onClick={this.handleSaveClick}
                        disabled={
                          this.state.isEmailValid === false ||
                          this.state.isPhoneValid === false ||
                          this.state.isCityValid === false ||
                          this.state.isPinValid === false ||
                          this.state.isAddressValid === false ||
                          this.state.isShippingAddressValid === false ||
                          this.state.isPanValid === false ||
                          this.state.isUsernameValid === false ||
                          this.state.isNameValid === false ||
                          this.state.isContactpValid === false ||
                          this.state.isPasswordValid === false ||
                          this.state.isUsernameUnique === false ||
                          (this.state.registrationType === 'Registered' &&
                            this.state.isGSTValid === false) ||
                          (this.state.registrationType === 'Registered' &&
                            this.state.gst === '') ||
                          (this.state.registrationType === 'Registered' &&
                            this.state.pan === '') ||
                          typeOfClient === '' ||
                          solution === '' ||
                          companyName === '' ||
                          username === '' ||
                          person === '' ||
                          email === '' ||
                          phoneno === '' ||
                          address === '' ||
                          address === null ||
                          pincode === null ||
                          city === '' ||
                          pincode === '' ||
                          state === '' ||
                          state === null ||
                          country === '' ||
                          plan === '' ||
                          salesPerson === '' ||
                          // registrationType === null ||
                          registrationType === '' ||
                          packetThreshold === '' ||
                          minimumTrackedDays === '' ||
                          packetThreshold === null ||
                          minimumTrackedDays === null ||
                          this.state.shippingAddress == null ||
                          this.state.shippingCity == null ||
                          this.state.shippingPincode == null ||
                          this.state.shippingCountry == null ||
                          this.state.shippingState == null ||
                          this.state.shippingAddress == '' ||
                          this.state.shippingCity == '' ||
                          this.state.isShippingCityValid == false ||
                          this.state.shippingPincode == '' ||
                          this.state.shippingCountry == '' ||
                          this.state.shippingState == '' ||
                          this.state.timezone == '' ||
                          this.state.isShippingPinvalid === false
                        }
                      >
                        Save
                      </Button>
                      <Button
                        color="secondary"
                        onClick={this.handleCancelClick}
                      >
                        Cancel
                      </Button>
                    </CardActions>
                  </Card>
                </Grid>
              </Grid>
            </div>
          )
        }}
      </Query>
    )
  }
}

EditCustomer.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(withApollo(withSharedSnackbar(EditCustomer)))



// WEBPACK FOOTER //
// ./src/components/Pages/EditCustomer/index.jsx